/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { TextInput, DeleteButton } from '../../atoms'
import { Edit } from '../../molecules'
import TaskAction from '../../../action/task'
import r from '../../../util/Renderer'

function TaskEditView(props) {
  const reservationId = props.location.state.reservationId

  return (
    <Edit
      title={props.task.id ? `タスクID：${props.task.id}` : '新規タスク'}
      buttonLabel={props.task.id ? '更新' : '作成'}
      onCancel={TaskAction.onCancelCreation}
      onSubmit={() => TaskAction.onRequestSave(reservationId, props.task)}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <TextInput value={props.task.title} type="text" name="title" onChange={e => TaskAction.onEdit(e)} placeholder="タイトル" label={'タイトル'} option="required" />
        </div>
      </div>
      <div className="EditArea__column">
        <p>ノート</p>
        <textarea className="EditArea__row--full" name="description" value={props.task.description} rows="6" onChange={e => TaskAction.onEdit(e)} />
      </div>
      {r.renderIf(props.task.id)(
        <div className="EditArea__Deletion">
          <DeleteButton className="delete-button" type="danger" size="lg" onClick={() => TaskAction.onRequestDelete(props.task.id, reservationId)}>
            削除
          </DeleteButton>
        </div>
      )}
    </Edit>
  )
}

export default TaskEditView
